import type { ReactNode } from "react";

import { Sheet, SheetBody, SheetContent, SheetHeader as SheetHeaderPrimitive } from "./Sheet";

export type DrawerProps = {
  open: boolean;
  onClose: () => void;
  children: ReactNode;
  className?: string;
};

export function Drawer({ open, onClose, children, className = "" }: DrawerProps) {
  return (
    <Sheet
      open={open}
      onOpenChange={(isOpen) => {
        if (!isOpen) onClose();
      }}
    >
      <SheetContent side="right" className={className}>
        {children}
      </SheetContent>
    </Sheet>
  );
}

export function DrawerHeader({ children, subtitle }: { children: ReactNode; subtitle?: string }) {
  return <SheetHeaderPrimitive subtitle={subtitle}>{children}</SheetHeaderPrimitive>;
}

export function DrawerBody({
  children,
  className = "",
}: {
  children: ReactNode;
  className?: string;
}) {
  return <SheetBody className={className}>{children}</SheetBody>;
}
